import React from "react";
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import NavBar from "../../layouts/navbar/navbar.component";
import StickyNav from "../../layouts/stickyNav/stickyNav.component";
import DrawerNav from "../../components/drawer/drawer.component";
import Footer from "../../layouts/footer/footer.component";
import AccessoriesMain from "../../layouts/accessoriesMain/accessoriesMain.layout";

const ProductPage = () => {
	return (
		<div>
			<TopOfNav />
			<StickyNav />
			<NavBar />
			<DrawerNav />
			<AccessoriesMain />
			<Footer />
		</div>
	);
};

export default ProductPage;
